'use strict'
import 'es6-promise/auto'
import localStorage from './localStorage'

class AuthService {
  static getOptions() {
    return { authToken: this.getJWT().token, role: this.getCurrentRole() }
  }

  static getJWT() {
    const obj = {}
    const token = this.getJWTToken()
    if (token) {
      obj.token = `Bearer ${token}`
    }
    return obj
  }

  static getCurrentRole() {
    return localStorage.getItem('_currentRole')
  }

  static getJWTToken() {
    return localStorage.getItem('_etp_token')
  }
}

export default AuthService
